import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const ServiciosPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const mainServices = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Conciliaciones',
      description: 'Actualmente la contabilidad se encuentra pasando por profundas transformaciones y adentrándose de lleno a la era digital, donde la información contable puede ser generada y procesada en cuestión de segundos.',
      features: [
        'Conciliación de Ingresos',
        'Conciliación de Nómina',
        'Conciliación de Egresos',
        'Creación de Catálogo de Cuentas',
        'Creación de Balanzas',
        'Creación de Pólizas',
      ],
    },
    {
      icon: 'ri-calculator-line',
      title: 'Contabilidad General',
      description: 'Nos regimos de acuerdo a las NIF para llevar un adecuado registro contable para enterar de manera puntual y eficiente las operaciones realizadas en un periodo determinado ante la autoridad.',
      features: [
        'Registro contable conforme a NIF',
        'Balanzas de comprobación',
        'Estados financieros',
        'Análisis de cuentas',
        'Reportes mensuales',
        'Asesoría contable continua',
      ],
    },
    {
      icon: 'ri-computer-line',
      title: 'Tecnología',
      description: 'Contamos con personal altamente calificado en herramientas de tecnología, reciba consultoría en la implementación de sistemas de gestión para el desarrollo de sus proyectos.',
      features: [
        'Implementación de sistemas',
        'Automatización de procesos',
        'Integración de plataformas',
        'Capacitación tecnológica',
        'Soporte técnico',
        'Optimización de recursos',
      ],
    },
  ];

  const additionalServices = [
    { name: 'Conciliación Contable', icon: 'ri-file-chart-line' },
    { name: 'Conciliación Fiscal', icon: 'ri-government-line' },
    { name: 'Conciliación de Ingresos', icon: 'ri-money-dollar-circle-line' },
    { name: 'Conciliación de Nóminas', icon: 'ri-user-settings-line' },
    { name: 'Catálogo de Cuentas', icon: 'ri-book-line' },
    { name: 'Creación de Balanzas', icon: 'ri-scales-3-line' },
    { name: 'Creación de Pólizas', icon: 'ri-file-text-line' },
    { name: 'Contabilidad Electrónica', icon: 'ri-cloud-line' },
    { name: 'Contabilidad General', icon: 'ri-calculator-line' },
    { name: 'Resoluciones ante el SAT', icon: 'ri-shield-check-line' },
    { name: 'Resoluciones ante IMSS', icon: 'ri-hospital-line' },
    { name: 'Consultoría Administrativa', icon: 'ri-briefcase-line' },
  ];

  const faqs = [
    {
      question: '¿Qué servicios de contabilidad ofrecen?',
      answer: 'Ofrecemos servicios completos de contabilidad general, conciliaciones, creación de balanzas y pólizas, estados financieros y asesoría contable continua conforme a las Normas de Información Financiera (NIF).',
    },
    {
      question: '¿Cómo pueden ayudarme con el SAT?',
      answer: 'Brindamos asesoría fiscal completa, preparación y presentación de declaraciones, resolución de requerimientos del SAT, y representación ante la autoridad fiscal para resolver cualquier situación.',
    },
    {
      question: '¿Qué incluye el servicio de nóminas?',
      answer: 'Nuestro servicio incluye cálculo de nómina, timbrado de recibos, cálculo de impuestos y cuotas obrero-patronales, presentación de declaraciones mensuales y anuales, y conciliación de nómina.',
    },
    {
      question: '¿Ofrecen consultoría para implementar sistemas?',
      answer: 'Sí, contamos con expertos en tecnología que pueden ayudarte a implementar sistemas de gestión, automatizar procesos contables y administrativos, e integrar diferentes plataformas para optimizar tu negocio.',
    },
    {
      question: '¿Cuánto tiempo toma obtener una respuesta?',
      answer: 'Nos comprometemos a responder todas las consultas en un plazo máximo de 24 horas hábiles. Para casos urgentes, ofrecemos atención inmediata vía telefónica o WhatsApp.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WhatsAppButton />

      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary via-primary-dark to-primary-light">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-heading font-bold text-5xl md:text-6xl text-white mb-6">Nuestros Servicios</h1>
          <p className="font-body text-xl text-white/90 max-w-3xl mx-auto">
            Soluciones integrales para tu negocio con la más alta calidad profesional
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading font-bold text-4xl text-primary mb-4">Catálogo de Servicios</h2>
            <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
            <p className="font-body text-lg text-gray-700 max-w-3xl mx-auto">
              Somos una empresa especializada en resolver y prevenir riesgos financieros, contables, administrativos y fiscales, mediante herramientas tecnológicas.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-20">
            {mainServices.map((service, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
              >
                <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-primary`}></i>
                </div>
                <h3 className="font-heading font-bold text-2xl text-primary mb-4">{service.title}</h3>
                <p className="font-body text-sm text-gray-600 leading-relaxed mb-6">{service.description}</p>
                <div className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-gold text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                      <span className="font-body text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading font-bold text-4xl text-primary mb-4">Otros Servicios</h2>
            <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
            <p className="font-body text-lg text-gray-700">
              Ponemos a su disposición servicios adicionales especializados
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {additionalServices.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:-translate-y-1 group"
              >
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-gold/20 transition-colors">
                    <i className={`${service.icon} text-xl text-primary group-hover:text-gold transition-colors`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-base text-gray-800">{service.name}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading font-bold text-4xl text-primary mb-4">Preguntas Frecuentes</h2>
            <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
            <p className="font-body text-lg text-gray-700">
              Respuestas a las dudas más comunes sobre nuestros servicios
            </p>
          </div>

          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-8 shadow-md hover:shadow-lg transition-shadow">
                <h3 className="font-heading font-bold text-lg text-primary mb-4 flex items-start">
                  <i className="ri-question-line text-gold text-xl mr-3 flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                  {faq.question}
                </h3>
                <p className="font-body text-sm text-gray-700 leading-relaxed ml-9">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-white mb-6">
            ¿Necesitas más información?
          </h2>
          <p className="font-body text-lg text-white/90 mb-8 max-w-2xl mx-auto">
            Contáctanos y con gusto te asesoraremos sobre el servicio que mejor se adapte a tus necesidades
          </p>
          <a
            href="/contacto"
            className="inline-block px-8 py-4 bg-gold hover:bg-gold/90 text-primary font-heading font-bold text-base rounded-lg transition-all duration-300 hover:scale-105 shadow-xl whitespace-nowrap"
          >
            Solicitar Información
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServiciosPage;